// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Lookup customer'"></sub-header>

  <!-- BANK lookup customer form -->
  <form class="filters" name="form">
    <div class="labelled-field labelled-field--short">
      <label for="dlc_cis">CIF number</label>
      <input ng-model="\$ctrl.searchParams.customerNumber" id="dlc_cis" type="text" autocomplete="off">
    </div>

    <div class="labelled-field labelled-field--short" ng-if="\$ctrl.permissions['CST_ALL_BRANCHES_ACCESS']">
      <label for="dlc_document">Document id</label>
      <input ng-model="\$ctrl.searchParams.documentNumber" id="dlc_document" type="text" autocomplete="off">
    </div>

    <div class="labelled-field labelled-field--short">
      <label for="dlc_name">Name</label>
      <input ng-model="\$ctrl.searchParams.name"
             id="dlc_name"
             type="text"
             autocomplete="off"
             title="{{\$ctrl.permissions['CST_ALL_BRANCHES_ACCESS'] ? null : 'For individual customer, kindly follow this format: Lastname, Firstname Extenstion Middlename'}}">
    </div>

    <div class="labelled-field labelled-field--short" ng-if="\$ctrl.permissions['CST_ALL_BRANCHES_ACCESS']">
      <label for="dlc_check_number">Check number</label>
      <input ng-model="\$ctrl.searchParams.checkNumber" id="dlc_check_number" type="text" autocomplete="off" maxlength="10">
    </div>

    <!-- Product number -->
    <div class="labelled-field labelled-field--long" ng-if="\$ctrl.permissions['CST_ALL_BRANCHES_ACCESS']">
      <label>Product number</label>
      <!-- MASKED product number -->
      <input ng-if="\$ctrl.showProductMask"
             id="mask-product-input"
             ng-model="\$ctrl.searchParams.productNumber"
             ui-mask="{{\$ctrl.productNumberMask}}"
             ui-options="{clearOnBlur: false}"
             model-view-value="true"
             class="extended"
             type="text"
             autocomplete="off"
      >
      <!-- NON-MASKED product number -->
      <input ng-if="!\$ctrl.showProductMask"
             ng-model="\$ctrl.searchParams.productNumber"
             class="extended"
             type="text"
             autocomplete="off">
    </div>
    <span class="mask-switch" ng-if="\$ctrl.productNumberMaskSaved && \$ctrl.permissions['CST_ALL_BRANCHES_ACCESS']" >
        <div ng-if="\$ctrl.showProductMask" id="mask-icon"><i class="icon icon-align-justify"></i></div>
        <div ng-if="!\$ctrl.showProductMask" id="normal-icon"><i class="icon icon-align-justify"></i></div>
        <input id="mask-checkbox" type="checkbox" ng-model="\$ctrl.showProductMask" ng-change="\$ctrl.switchProductMask()"/>
    </span>

    <div class="labelled-field labelled-field--short" ng-if="!\$ctrl.permissions['CST_ALL_BRANCHES_ACCESS']">
      <label>Birth date / Registration date</label>
      <date init-with-null="true"
            output-format="local-date"
            ng-model="\$ctrl.referenceDate">
      </date>
    </div>

    <button class="btn btn-primary search-button" ng-click="\$ctrl.search()" ng-disabled="!\$ctrl.validSearchRequest()">
      Search
    </button>
    <button
      ng-disabled="!\$ctrl.createCustomerEnabled"
      class="btn btn-disabled search-button"
      ng-class="{'btn-primary': \$ctrl.createCustomerEnabled}"
      ng-click="\$ctrl.createCustomer()">
      New customer
    </button>
  </form>

  <div class="empty-message" ng-if="!\$ctrl.searchPerformed">
    <span>Please enter search criteria to lookup customer</span>
  </div>

  <div class="empty-message" ng-if="\$ctrl.emptyResults()">
    <span>No customers matching the given criteria exist</span>
  </div>

  <table ng-show="\$ctrl.showResults()" class="table" ng-table="\$ctrl.tableConfig">
    <thead>
      <tr>
        <th>No</th>
        <th>CIF Number</th>
        <th>Name</th>
        <th ng-if="\$ctrl.isMembershipTypeVisible()">Membership Type</th>
        <th>Type</th>
        <th>Status</th>
        <th>Branch</th>
        <th></th>
      </tr>
    </thead>
    <tr ng-repeat="result in \$data">
      <td>{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
      <td>{{result.customerNumber}}</td>
      <td>{{result.name}}</td>
      <td ng-if="\$ctrl.isMembershipTypeVisible()">{{result.membershipType}}</td>
      <td>{{result.typeDescription}}</td>
      <td>{{result.customerStatus}}</td>
      <td>{{\$ctrl.branchNames[result.branchId]}}</td>
      <td>
        <span ng-show="\$ctrl.isOpenButtonEnabled(result.customerStatus)">
          <button ng-click="\$ctrl.openCustomer(result)"
                  class="btn btn-primary">Open
          </button>
        </span>
        <span ng-show="result.customerStatus === 'PROSPECT'" >
          <button disabled class="btn btn-disabled">Requires approval</button>
        </span>
      </td>
    </tr>
  </table>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/lookup-customer/lookup-customer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;